// @flow strict

import { createContext } from 'react';

export default createContext<() => void>(() => {});
